import { AuswahlDDB } from './AuswahlDDB';

export const BenutzerRollen = {
  System: BigInt(1n << 0n),
  Entwickler: BigInt(1n << 1n),
  HLS_AlleRegulierer: BigInt(1n << 2n),
  HLS_Kundenservice: BigInt(1n << 3n),
  Reklamationen: BigInt(1n << 4n),
  HLS_IHL_Leitung: BigInt(1n << 5n),
  HLS_Versorgungsassistent: BigInt(1n << 6n),
  HLS_Projektmitarbeiter: BigInt(1n << 7n),
  Stationsleitung: BigInt(1n << 8n),
  Pflegedienstleitung: BigInt(1n << 9n),
  HLS_Einkauf: BigInt(1n << 10n),
  HLS_Dispo: BigInt(1n << 11n),
  Verbrauchsstatistik: BigInt(1n << 12n),
  Stammdaten_Schränke: BigInt(1n << 13n),
  StatistikSanaAuswahl: BigInt(1n << 14n),
  Einkauf_Extern: BigInt(1n << 15n),

  HLS_ALLE: BigInt((1n << 3n) | (1n << 5n) | (1n << 7n) | (1n << 10n) | (1n << 11n)), // nicht Versorgungsassistent
  // MAXIMAL << 126 möglich
};

// Rollen System und Entwickler werden NICHT in der normalen Liste zum Bearbeiten der Berechtigungen angezeigt.
// Hier bitte die Reihenfolge so anlegen, wie die Einträge angezeigt werden sollen.
export const BenutzerRollenListe: AuswahlDDB[] = [
  new AuswahlDDB(BenutzerRollen.HLS_AlleRegulierer, 'HLS - alle Regulierer'),

  new AuswahlDDB(BenutzerRollen.HLS_Kundenservice, 'HLS - Kundenservice'),
  new AuswahlDDB(BenutzerRollen.HLS_Einkauf, 'HLS - Einkauf'),
  new AuswahlDDB(BenutzerRollen.HLS_Dispo, 'HLS - Dispo'),
  new AuswahlDDB(BenutzerRollen.HLS_Projektmitarbeiter, 'HLS - Projektmitarbeiter'),
  new AuswahlDDB(BenutzerRollen.HLS_Versorgungsassistent, 'HLS - VA (Inhouse Logistik)'),
  new AuswahlDDB(BenutzerRollen.HLS_IHL_Leitung, 'HLS - VA Leitung (Inhouse Logistik)'),

  new AuswahlDDB(BenutzerRollen.Einkauf_Extern, 'Einkauf Extern'),
  new AuswahlDDB(BenutzerRollen.Pflegedienstleitung, 'Pflegedienstleitung'),
  new AuswahlDDB(BenutzerRollen.Stationsleitung, 'Stationsleitung'),
  new AuswahlDDB(BenutzerRollen.Reklamationen, 'Reklamationen'),

  new AuswahlDDB(BenutzerRollen.Verbrauchsstatistik, 'Verbrauchsstatistik'),
  new AuswahlDDB(BenutzerRollen.StatistikSanaAuswahl, 'Statistik Sana Auswahl'),
];
